import axios from '../utils/axios'

// 邀请评价页面数据获取
export function SAppEvaluateList (params) {
  return axios({
    url: '/SaleV2/Evaluate/SAppEvaluateList',
    method: 'get',
    params: params
  })
}

// 获取可评价订单接口
export function GetCanEvaluateOrderList (params) {
  return axios({
    url: '/SaleV2/Evaluate/GetCanEvaluateOrderList',
    method: 'get',
    params: params
  })
}

// 评价邀请-审核不通过
export function AuditNoPassRemarkGet (params) {
  return axios({
    url: '/SaleV2/Evaluate/AuditNoPassRemarkGet',
    method: 'get',
    params: params
  })
}

// 评价邀请-查看评价
export function ShowEvaluatePic (params) {
  return axios({
    url: '/SaleV2/Evaluate/ShowEvaluatePic',
    method: 'get',
    params: params
  })
}

// 提交评价--获取数据
export function SAppEvaluateInfoGet (params) {
  return axios({
    url: '/SaleV2/Evaluate/SAppEvaluateInfoGet',
    method: 'get',
    params: params
  })
}

// 取消评价接口
export function CancelEvaluate (params) {
  return axios({
    url: '/SaleV2/Evaluate/CancelEvaluate',
    method: 'get',
    params: params
  })
}

// 提交评价--提交数据
export function SAppEvaluateSubmit (data) {
  return axios({
    url: '/SaleV2/Evaluate/SAppEvaluateSubmit',
    method: 'post',
    data: data
  })
}
